module.exports = __webpack_public_path__ + "img/64.b3474250.jpg";